import styled from 'styled-components';
import theme from 'styled-theming';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
export var StyledCallout = styled.div.withConfig({
  displayName: "Calloutstyles__StyledCallout",
  componentId: "sc-sy88n4-0"
})(["background:var(--dentsu-color-n50);padding:0 8.333%;"]);
export var StyledCalloutInner = styled.div.withConfig({
  displayName: "Calloutstyles__StyledCalloutInner",
  componentId: "sc-sy88n4-1"
})(["display:flex;padding:48px 24px;flex-direction:column;font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-16);color:var(--dentsu-color-black);line-height:", ";@media (min-width:1024px){flex-direction:", ";}"], rem(24), theme('layout', {
  horizontal: 'row'
}));
export var StyledContent = styled.div.withConfig({
  displayName: "Calloutstyles__StyledContent",
  componentId: "sc-sy88n4-2"
})(["width:100%;padding:0 0 24px 0;@media (min-width:1024px){width:", ";padding:", ";}"], theme('layout', {
  horizontal: '50%'
}), theme('layout', {
  horizontal: '0 24px 0 0'
}));
export var StyledTitle = styled.h3.withConfig({
  displayName: "Calloutstyles__StyledTitle",
  componentId: "sc-sy88n4-3"
})(["font-weight:var(--dentsu-font-weight-semibold);font-size:var(--dentsu-font-size-24);color:var(--dentsu-color-black);line-height:", ";margin-bottom:var(--dentsu-spacing-12);"], rem(32));
export var StyledDescription = styled.div.withConfig({
  displayName: "Calloutstyles__StyledDescription",
  componentId: "sc-sy88n4-4"
})([".", "-link{font-size:1em;}"], prefix);
export var StyledActions = styled.div.withConfig({
  displayName: "Calloutstyles__StyledActions",
  componentId: "sc-sy88n4-5"
})(["border-top:1px solid var(--dentsu-color-n300);width:100%;padding:24px 0 0 0;.", "-link{font-size:1em;}@media (min-width:1024px){border-top:", ";border-left:", ";padding:", ";width:", ";}.dentsu-select .dentsu-select__control,.dentsu-chip-input .dentsu-chip-input__control,.dentsu-text-.bp3-input,.dentsu-textarea,.dentsu-currency-input,.dentsu-dateinput .bp3-input,.dentsu-daterangeinput .bp3-input,.dentsu-numeric-input{background:var(--dentsu-color-white);}.dentsu-fileinput .bp3-file-upload-input{background:var(--dentsu-color-white) !important;}.dentsu-dateinput .bp3-input-action,.dentsu-daterangeinput .bp3-input-action{padding-top:7px;}"], prefix, theme('layout', {
  horizontal: 'none'
}), theme('layout', {
  horizontal: "1px solid var(--dentsu-color-n300)"
}), theme('layout', {
  horizontal: '0 0 0 24px'
}), theme('layout', {
  horizontal: '50%'
}));